module.exports = __webpack_public_path__ + "static/img/PSD63-A.cc26cdc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productConter/params/PSD63-A.png
// module id = 0HZA
// module chunks = 1